import { useState } from "react";

const CHAT_OPEN_KEY = "prism:chat:open";

export function useChatVisibility(defaultOpen = true): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => {
    try {
      const saved = localStorage.getItem(CHAT_OPEN_KEY);
      return saved !== null ? saved === "true" : defaultOpen;
    } catch {
      return defaultOpen;
    }
  });

  const handleChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    localStorage.setItem(CHAT_OPEN_KEY, String(nextOpen));
  };

  return [open, handleChange];
}
